require([
    "jquery",
    "services",
    "smoothscroll-polyfill"
], function($) {
    /**
     * default top offset
     *
     * @type {number}
     */
    var defaultOffset = 0;

    /**
     * When in a mobile device we should adjust the scroll (top) by the header bar
     *
     * @type {number}
     */
    var mobileOffset = 0;

    /**
     * get the base offset for all scrollTo animations
     *
     * @returns {number}
     */
    function getOffset() {
        var offset = defaultOffset;

        // give a little extra bump on mobile
        if (CH && CH.isMobile) {
            offset += mobileOffset;
        }

        return offset;
    }

    /**
     * scroll to a vertical position in the page
     *
     * @param {number} top
     */
    CH.scrollTo = function (top) {
        top = parseInt(top) - getOffset();

        window.scroll({
            top: top,
            left: 0,
            behavior: 'smooth'
        });
    };

    /**
     * Scroll viewport to an element in the page
     *
     * @param {jQuery} $element
     */
    CH.scrollToElement = function ($element) {
        if ($element.length > 0) {
            $element.get(0).scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        }
    }

    // run once css is parsed
    // @todo temporarily checking if this function exists to prevent race-condition bugs from requirejs & services.js
    typeof window.onWindowLoad === 'function' && window.onWindowLoad(function() {
        var offset;
        
        if (
            typeof $.urlParamIsSet === 'function' &&
            $.urlParamIsSet('error')
        ) {
            // Scroll to form on errors
            offset = $._($.urlParam('error')).offset();
        } else if (window.location.hash === '#form') {
            // Scroll to form shortcut
            offset = $('form:visible').offset();
        }

        if (offset && offset.top) {
            CH.scrollTo(offset.top - 250);
        }
    });
});

define("ch_scrollto", function(){});

